const routes = [
  {
    path: '/error/:errorType',
    name: 'userError',
    component: () => import(/* webpackChunkName: "UserErrorPage" */ './views/UserErrorPage.vue'),
    meta: { i18n: 'error-page-pov', pageNameEn: 'Error' },
    props: (route) => ({ ...route.params }),
  },
];

export default routes;
